'use client';

import { PRODUCT_HIGHLIGHTS } from 'lib/constants';
import { Award, Flame, Dumbbell, PackageCheck } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import SectionHeading from 'components/ui/SectionHeading';
import { staggerContainer, staggerItem } from 'lib/utils';

const iconMap = {
  Award,
  Flame,
  Dumbbell,
  PackageCheck
};

export default function ProductHighlights() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-Mora-beige/30 relative overflow-hidden border-y border-Mora-caramel/15" ref={ref}>
      {/* Decorative ambient glow */}
      <div className="absolute top-0 right-1/4 w-80 h-80 bg-Mora-caramel/10 rounded-full blur-3xl pointer-events-none -translate-y-1/2" />
      <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-Mora-peanut/10 rounded-full blur-3xl pointer-events-none translate-y-1/2" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20 relative z-10">

        <SectionHeading
          eyebrow="OUR PROMISE"
          title="The Premium Difference"
          subtitle="What sets MORA Enterprise Bengaluru Sopari apart with quality, tradition, and a distinctive identity."
          className="mb-8 sm:mb-12 md:mb-14"
        />

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8"
          variants={staggerContainer}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {PRODUCT_HIGHLIGHTS.map((highlight, index) => {
            const Icon = iconMap[highlight.icon] || Award;

            return (
              <motion.div
                key={index}
                variants={staggerItem}
                className="group bg-white p-5 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl shadow-md hover:shadow-2xl border border-Mora-caramel/20 hover:border-Mora-caramel transition-all duration-300 transform hover:-translate-y-1.5 flex flex-col items-center text-center h-full relative z-10"
              >
                <div className="w-12 sm:w-14 md:w-16 h-12 sm:h-14 md:h-16 rounded-full bg-Mora-beige/70 flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-Mora-caramel transition-colors duration-300 shadow-sm">
                  <Icon className="w-6 sm:w-7 md:w-8 h-6 sm:h-7 md:h-8 text-Mora-brown group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-heading text-lg sm:text-xl text-Mora-dark mb-2 sm:mb-3 font-semibold">
                  {highlight.title}
                </h3>
                <p className="font-body text-Mora-dark/70 text-sm sm:text-base leading-relaxed">
                  {highlight.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
